var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#DDE8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 42H39.3333C40.8061 42 42 40.8061 42 39.3333V20.6667C42 19.1939 40.8061 18 39.3333 18H20.6667C19.1939 18 18 19.1939 18 20.6667V39.3333C18 40.8061 19.1939 42 20.6667 42ZM20.6667 42L35.3333 27.3333L42 34M27.3333 25.3333C27.3333 26.4379 26.4379 27.3333 25.3333 27.3333C24.2288 27.3333 23.3333 26.4379 23.3333 25.3333C23.3333 24.2288 24.2288 23.3333 25.3333 23.3333C26.4379 23.3333 27.3333 24.2288 27.3333 25.3333Z",
    stroke: "#0B7CDA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeImage);
export default __webpack_public_path__ + "static/media/safe-image.07041012688cd5d00346871af56733a6.svg";
export { ForwardRef as ReactComponent };